export default __webpack_public_path__ + "media/images/pic-bg-c5ce914907dcbdc459ddd9c88ee8c5bd.png";